import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import style from './Section01.module.css'
import secIcon01 from '../images/sec01_img01.png'
import secIcon02 from '../images/sec01_img02.png'
import secIcon03 from '../images/sec01_img03.png'


function Section01({sec01Ref}) {

    const { t } = useTranslation();

    return (
        <section className={style.wrap} ref={sec01Ref}>
            <div className={style.sec_title}>
                <h4>
                    {t('We provide a stable supply of the essential raw materials')} <br />
                    {t('and devices at the core of the e-cigarette industry.')}
                </h4>
            </div>
            <div className={style.sec_item_box}>
                <div className={style.sec_item}>
                    <div className={style.item_img}>
                        <img src={secIcon01} alt='합성 니코틴 수출' />
                    </div>
                    <div className={style.item_text}>
                        <h5>{t('Export of synthetic nicotine')}</h5>
                        <p>{t('Exclusive export of high-purity nicotine')} <br />
                            {t('with the only domestic synthetic nicotine maker.')}</p>
                    </div>
                </div>
                <div className={style.sec_item}>
                    <div className={style.item_img}>
                        <img src={secIcon02} alt='합성 니코틴 수출' />
                    </div>
                    <div className={style.item_text}>
                        <h5>{t('E-liquid supply')}</h5>
                        <p>{t('We reliably supply e-liquids tailored to diverse')}<br />
                            {t('needs to domestic and international partners.')}</p>
                    </div>
                </div>
                <div className={style.sec_item}>
                    <div className={style.item_img}>
                        <img src={secIcon03} alt='합성 니코틴 수출' />
                    </div>
                    <div className={style.item_text}>
                        <h5>{t('E-cigarette device import agency')}</h5>
                        <p>{t('We import devices from manufacturers')} <br />
                            {t('and handle the entire import process.')}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Section01;